import { IOkved } from 'APIPackage/KnmModule/interfaces/IOkved';
import { deleteObjectProperties } from 'CorePackage/MainModule/common/deleteObjectProperties';
import { IKnmFormOkved } from 'KnmPackage/MainModule/interfaces/IKnmFormOkved';

export const convertKnmOkvedsFormValueToKnmData = (formOkveds: IKnmFormOkved[] | undefined): IOkved[] | null => {
  return (
    formOkveds?.reduce((filteredOkveds: IOkved[] | null, formOkvedsItem) => {
      let newFilteredOkveds = filteredOkveds ? [...filteredOkveds] : null;

      if (formOkvedsItem.okved) {
        if (!newFilteredOkveds) {
          newFilteredOkveds = [];
        }
        newFilteredOkveds.push({
          ...deleteObjectProperties(formOkvedsItem.okved, ['label', 'value']),
        });
      }

      return newFilteredOkveds;
    }, null) || null
  );
};
